import React from "react";
import FirstScreen from "./FirstScreen";
import SecondScreen from "./SecondScreen";
import { Tab, Tabs } from "react-bootstrap";

import './styles.scss';

const ScreensContent = (
    {
        eventSettings,
        eventName,
        accessPreModeration,
        onChangeModel,
        onChangeScreen,
    }
) => {
    const handleChangeFormVisibility = (key) => {
        onChangeScreen(key === 'FirstScreen');
    };

    return (
        <Tabs
            id="episode-tabs"
            defaultActiveKey="FirstScreen"
            className="screens-content"
            onSelect={handleChangeFormVisibility}
        >
            <Tab
                eventKey="FirstScreen"
                title="Первый экран"
            >
                <FirstScreen
                    eventSettings={eventSettings}
                    accessPreModeration={accessPreModeration}
                    onChange={onChangeModel}
                />
            </Tab>
            <Tab
                eventKey="SecondScreen"
                title="Второй экран"
            >
                <SecondScreen
                    eventSettings={eventSettings}
                    eventName={eventName}
                    accessPreModeration={accessPreModeration}
                    onChange={onChangeModel}
                />
            </Tab>
        </Tabs>
    );
};

export default ScreensContent;
 